module.exports = require('next/document')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dist/pages/_document.js
// module id = ./node_modules/next/dist/pages/_document.js
// module chunks = 1